package games.mythical.saga.watcher.sagawatcher.model

import kotlinx.serialization.Serializable

@Serializable
data class AppVersions(
    val applications: MutableMap<String, Application>,
)